import { InitialLoadEditSources } from './constants';

export const isLoadingFromCreate = (editSource: string) => editSource?.indexOf('CREATE_') === 0; // See constants.ts

export const isJSOnlyPreloadEditSources = (editSource: string) =>
	isLoadingFromCreate(editSource) || InitialLoadEditSources.includes(editSource);

export const isEditSourceInitialLoad = (editSource: string) =>
	InitialLoadEditSources.includes(editSource);
